export const UserRoleTypeEnum = {
  Administrator: "Administrator",
  TransactionEntry: "TransactionEntry",
  ReadOnly: "ReadOnly"
};

export class UserClaims {
  name = ""; // display name--this will default to 'unknown' if claim exists but wasnt provided by user.
  given_name = ""; // first name
  family_name = ""; // last name
  emails = [""];
  streetAddress = "";
  city = "";
  postalCode = "";
  state = "";
  country = "";
  jobTitle = ""; // used for company in our case
  oid = ""; // Object identifier (ID) of the user object in Azure AD.
  newUser = false; // if the user just signed up
  email = "";
  preferred_username = "";
  roles = [];
  userId = "";
  in_corp = false;
  constructor(initObj) {
    if (initObj) {
      Object.keys(initObj).forEach(key => !initObj[key] && delete initObj[key]);
      Object.assign(this, initObj);
    }
  }
}

export function userInRole(currentUser, role) {
  const isInRole =
    currentUser && currentUser.roles
      ? currentUser.roles.indexOf(role) > -1
      : false;
  return isInRole;
}

export function userInRoles(currentUser, roles) {
  const isInRole = roles.some(r => userInRole(currentUser, r));
  return isInRole;
}

/**
 * Returns true if user has an assigned role
 */
export function hasValidRole(currentUser) {
  const validRoles = [
    UserRoleTypeEnum.Administrator,
    UserRoleTypeEnum.TransactionEntry,
    UserRoleTypeEnum.ReadOnly
  ];
  var isValid = false;

  if (currentUser !== null && currentUser !== undefined) {
    currentUser.roles.forEach(r => {
      if (validRoles.indexOf(r) > -1) {
        isValid = true;
      }
    });
  }

  return isValid;
}

export function isAdministrator(currentUser) {
  return currentUser
    ? currentUser.roles.indexOf(UserRoleTypeEnum.Administrator) > -1
    : false;
}

export function isReadOnly(currentUser) {
  return currentUser
    ? currentUser.roles.indexOf(UserRoleTypeEnum.ReadOnly) > -1
    : false;
}

export function isTransactionEntry(currentUser) {
  return currentUser
    ? currentUser.roles.indexOf(UserRoleTypeEnum.TransactionEntry) > -1
    : false;
}

export class AuthService {
  /**
   * converts list of claims into an object of claimType:value pairs
   *
   */
  parseRawClaims(claims) {
    const claimObj = {
      roles: []
    };
    let selectedClaims = [];
    selectedClaims = claims.map(c => ({
      type: this.getFriendlyClaimType(c.type),
      value: c.value
    }));
    selectedClaims.forEach(c => {
      if (c.type === "role") {
        claimObj.roles.push(c.value);
      } else {
        claimObj[c.type] = c.value;
      }
    });

    return claimObj;
  }

  /**
   * Returns the meaningful part of the claimType.
   * 'http://schemas.xmlsoap.org/ws/2005/05/identity/claims/emailaddress' would become emailaddress
   *
   * @private
   * @param {string} fullClaimType
   * @returns
   * @memberof AppServerAuthService
   */
  getFriendlyClaimType(fullClaimType) {
    return fullClaimType
      .substr(fullClaimType.lastIndexOf("/") + 1)
      .toLowerCase();
  }

  /**
   * Maps raw list of claims in a new UserClaims object
   */
  getUserClaims(rawClaims) {
    const claimObj = this.parseRawClaims(rawClaims) || {};
    const claims = new UserClaims({
      name: claimObj.name,
      given_name: claimObj.given_name || claimObj.givenname,
      family_name: claimObj.family_name || claimObj.surname,
      emails: claimObj.emails || claimObj.unique_name,
      streetAddress: claimObj.streetAddress,
      city: claimObj.city,
      postalCode: claimObj.postalCode,
      state: claimObj.state,
      country: claimObj.country,
      jobTitle: claimObj.jobTitle,
      oid: claimObj.oid || claimObj.objectidentifier,
      newUser: claimObj.newUser,
      email: claimObj.email || claimObj.unique_name || claimObj.emailaddress,
      preferred_username: claimObj.preferred_username || claimObj.unique_name,
      in_corp: claimObj.in_corp || false,
      roles: claimObj.roles || [],
      userId: claimObj.name.substring(0, claimObj.name.indexOf("@"))
    });

    return claims;
  }

  /**
   * Logs in the user according to the provided configuration.
   * Defaults to full page redirect when signing in.
   *
   * @memberof AppServerAuthService
   */
  login() {
    const loginUrl = "/Account/Login";
    window.location.href = loginUrl;
  }

  async getUserInfo() {
    const userInfoUrl = "api/v1.0/user/getuserinfo";

    let currentUser = null;
    try {
      const response = await fetch(userInfoUrl, {
        pragma: "no-cache",
        "cache-control": "no-cache"
      });

      currentUser = await response.json().then(userInfo => {
        return this.getUserClaims(userInfo);
      });
    } catch (error) {
      currentUser = null;
      if (error.status === 403) {
        this.currentUser = new UserClaims({
          roles: ["unauthorized"],
          name: "Unauthorized User"
        });
      }
    }
    return currentUser;
  }
}
